export default {
  News: '新闻中心',
  'News Detail': '新闻详情'
}
